import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import DataTable from 'src/Components/DataTable';
import { IRole } from 'src/Interfaces/AdminInterface';
import { AdminStore } from 'src/Stores/Admin/AdminStore';
import { UserStore } from 'src/Stores/User/UserStore';

@inject('stores')
@observer
class AdminRoles extends React.Component {


    private AdminStore: AdminStore;
    private UserStore: UserStore;
    
    private tableHeaders = [
        { content: 'Role Name', 'class': 'align-left' },
        { content: 'Description', 'class': 'align-left' },
    ];

    constructor(props: any) {
        super(props);
        this.AdminStore = props.stores.AdminStore;
        this.UserStore = props.stores.UserStore;
    }
    public componentDidMount() {
        if(this.AdminStore.roles.length === 0) {
            this.AdminStore.getRoles();
        }
    }

    private createRoleDetailLink = (role: IRole) => () => {
        if (role.name === 'SuperAdmin') {
            return role.name;
        }
        return (
            <Link key={role.id} to={'/admin/roles/' + role.id}>{role.name}</Link>
        );
    }
    private formatRolesData = (roles: IRole[]) => {
        const rows = roles.map((value, index) => {
            return [
                {
                    content: this.createRoleDetailLink(value),
                    sortItem: value.name,
                    type: 'render',
                },
                {
                    content: value.description,
                    sortItem: value.description ? value.description : '',
                }
            ];
        });

        return { headers: this.tableHeaders, rows};
    }
    public render() {
        return (
            <div>
                <Row className='header'>
                    <Col md="6">
                        <h1>Roles</h1>
                    </Col>
                    {
                        this.UserStore.hasPermission('Permissions.Admin.Roles.Create') &&
                        <Col md="6">
                            <Link to="/admin/roles/new">
                                <Button color="primary" className="float-right">
                                    Add New Role
                                </Button>
                            </Link>
                        </Col>
                    }
                </Row>
                <Row>
                    <Col>
                        <DataTable
                            list={this.formatRolesData(this.AdminStore.roles)}
                        />
                    </Col>
                </Row>
            </div>
        );
    }

}

export default AdminRoles;


// WEBPACK FOOTER //
// ./src/Components/Main/Admin/Roles/AdminRoles.tsx